module.exports = __webpack_public_path__ + "static/img/soamaa.82910ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soamaa.jpg
// module id = 516
// module chunks = 1